// main.jsx — Vite entry point.
//
// Order matters:
//   1. BrowserRouter must be the outermost so all hooks (useNavigate,
//      useLocation, etc.) work everywhere.
//   2. AuthProvider sits inside BrowserRouter because some of its callbacks
//      (e.g. login() success → navigate) may use router hooks via children.
//   3. App is the route table itself.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './lib/AuthContext.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>,
);
